module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAMxJREFUSA1jYBgFwz4EmCn0ISNQfxwQfwHi9xSahaEdZPgcIP4PxC+BWBuIqQqUgaaBXA2yAGYJSAwFMKHwiOOAXN4FxKxA7ArEH4AYBMSA2BrMooBADpbnQHM0gNgEiEE+AQUXSJ5sgGw4LFhgloCChuqGwywBBRdFAJvLYYbTJFhGDQenBlgOhQUHjKY4zEGpIReIYQYi02QZji0nC2FJc3OBYqlQi7FI4xbCZgG6arINBxmELffZA8UdQJJA8A6IpwAxKKhGAW1CAACtV0ar8EYyfgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarEditorPage/components/carData/img/edit.png
// module id = 1703
// module chunks = 0